import React from "react";
import { ShieldCheck, Mail } from "lucide-react";
import PageShell, { Section } from "@/components/PageShell";

const PRINCIPLES = [
  "Secure data handling",
  "Encrypted communications",
  "Access controls",
  "Identity verification procedures",
  "Ongoing security monitoring",
  "Privacy-first design principles",
];

const Security = () => (
  <PageShell
    eyebrow="// Security"
    title="Security"
    subtitle="Protecting user information is a top priority."
    testid="security-page"
  >
    <Section>
      <p>
        GigAfloat is committed to implementing industry-standard security practices as the platform evolves. Below is an overview of the principles guiding how we build, store, and access user data.
      </p>
    </Section>

    <Section title="Our goals">
      <ul className="grid sm:grid-cols-2 gap-3 list-none pl-0">
        {PRINCIPLES.map((p) => (
          <li
            key={p}
            className="flex items-start gap-3 rounded-2xl border border-white/8 bg-white/[0.02] p-4"
            data-testid={`security-principle-${p.toLowerCase().replace(/\s/g, "-")}`}
          >
            <span className="w-8 h-8 rounded-xl bg-[#00FF88]/10 border border-[#00FF88]/30 grid place-items-center shrink-0">
              <ShieldCheck className="w-4 h-4 text-[#00FF88]" />
            </span>
            <span className="text-white/80 text-sm leading-relaxed pt-1.5">{p}</span>
          </li>
        ))}
      </ul>
    </Section>

    <Section title="Report a security concern">
      <p>
        If you discover a potential security concern, please report it immediately. We treat every report seriously and confidentially.
      </p>
      <a
        href="mailto:gigafloatapp@gmail.com?subject=Security%20Report"
        className="mt-3 inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-6 py-3 rounded-full btn-glow"
        data-testid="security-report-cta"
      >
        <Mail className="w-4 h-4" />
        Report a security concern
      </a>
    </Section>
  </PageShell>
);

export default Security;
